module.exports = __webpack_public_path__ + "static/media/camping.b7f012f5.png";